import React, { useState, useEffect } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  doctorSingleUserMeetingStatus,
  patientMeetingStatus,
  updateAppoinmentStatus,
} from "../../../api/apiHandler.js";
import Header from "../../../components/header/Header.js";
import Footer from "../../../components/footer/Footer.js";
import constant from "../../../constant/constant.js";
import Select from "react-select";
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import moment from "moment-timezone";
import { Dropdown, Form } from "react-bootstrap";
import { EmailMeetingRecordsPopup } from "../../../modal/emailMeetingRecordsPopup/index.js";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import queryString from "query-string";

function SingleUserHistory() {
  const navigate = useNavigate();
  const [patientMeetingStatusList, setPatientMeetingStatusList] = useState([]);
  const [totalRecordCount, setTotalRecordCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [userTimezone, setUserTimezone] = useState("");
  const [selectLang, setSelectLang] = useState({});
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isOpen, setIsOpen] = useState(false);
  const [meetingId, setMeetingId] = useState("");
  const [refresh, setRefresh] = useState(false);
  const userRole = localStorage.getItem("user_login_type_role");
  // console.log("currentTime",moment(currentTime).format('DD/MM/YYYY hh:mm A'));
  console.log("selectLang-->", selectLang);
  const location2 = useLocation();

  const params = queryString.parse(window.location.search);
  console.log(params);

  const doctorSpecialities = [
    { value: 0, label: "All" },
    //{ value: 1, label: "PENDING" },
    { value: 2, label: "ACCEPTED" },
    // { value: 3, label: "REJECTED" },
    { value: 4, label: "ONGOING" },
    { value: 5, label: "DONE" },
    { value: 6, label: "CANCELLED" },
  ];

  const [selectedStatus, setSelectedStatus] = useState(doctorSpecialities[0]);

  const selectLangFunc = async (e, id) => {
    try {
      console.log(e.target.value, id);
      let obj = { ...selectLang, [id]: e.target.value };
      console.log("testtt==>", obj);
      setSelectLang(obj);
    } catch (error) {}
  };

  useEffect(() => {
    // const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezone = moment.tz.guess();
    setUserTimezone(timezone);
    if (searchQuery == "") {
      Swal.fire({
        title: "Please wait...",
        didOpen: () => {
          Swal.showLoading();
        },
      });
    }

    doctorSingleUserMeetingStatus({
      page: pageNo,
      record_count: perPage,
      isPriestMeeting:
        params.isPriestMeeting == "true" || userRole == "4" ? 1 : 0,
    })
      .then((response) => {
        Swal.close();
        response = JSON.parse(response);
        console.log("response&*", response);
        if (response.code == process.env.REACT_APP_SUCCESS) {
          console.log("response.data.patient_data-->*&&^??", response.data);
          const defaultSelections = {};
          response.data.response.forEach((item) => {
            defaultSelections[item.id] = item.doctor_language || "English";
          });
          setSelectLang(defaultSelections);
          setPatientMeetingStatusList(response.data.response);
          console.log(response.data, "meetingstatusdattatatatatat");

          setTotalRecordCount(
            Math.ceil(response.data.total_record_count / perPage)
          );
        } else {
          setPatientMeetingStatusList([]);
          setTotalRecordCount(1);
        }
        setRefresh(false);
      })
      .catch((err) => {
        console.log("^^&&&()()", err);
      });

    // Swal.close();
  }, [searchQuery, pageNo, refresh, selectedStatus, params?.isPriestMeeting]);

  const handlePageClick = (event) => {
    setPageNo(event.selected + 1);
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const handleAutoRx = async () => {
    try {
      if (userRole == "4") {
        navigate("/priest/carepoint/1");
      } else if (userRole == "1") {
        navigate("/patient/carepoint/1");
      } else {
        navigate("/doctor/carepoint/1");
      }
    } catch (error) {}
  };

  const isOpenMailModal = (meetingId) => {
    setIsOpen(true);
    setMeetingId(meetingId);
  };

  const handleMeetiRecord = async (id) => {
    try {
      if (userRole == "4") {
        navigate(`/priest/meeting-single-user-record/${id}`);
      } else if (userRole == "1") {
        let priest =
          params.isPriestMeeting == "true"
            ? "isPriestMeeting=true"
            : "isPriestMeeting=false";
        navigate(`/patient/meeting-single-user-record/${id}?${priest}`);
      } else {
        navigate(`/doctor/meeting-single-user-record/${id}`);
      }
    } catch (error) {}
  };

  return (
    <>
      <Header />
      <EmailMeetingRecordsPopup
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        meetingId={meetingId}
        setMeetingId={setMeetingId}
        isuserpage={true}
      />
      <section className="doctorsec-pad">
        <div className="container">
          <div className="mt-4">
            <p className="font_22 font_600 mb-0">Meeting Single User Status </p>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link
                    to={userRole == "4" ? `/priest/home` : `/doctor/home`}
                    className="font_14"
                  >
                    Home
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active font_14"
                  aria-current="page"
                >
                  Meeting Single User Status
                </li>
              </ol>
            </nav>
          </div>
          <div className="card">
            <div className="card-body doctor-table-card">
              <div
                className="row justify-content-between position-relative"
                style={{ zIndex: 99 }}
              >
                <div className="search-bar col-lg-3 col-md-3">
                  <label
                    htmlFor="statusFilter"
                    className="white-space-nw"
                    style={{ marginRight: "8px", fontSize: "14px" }}
                  >
                    Filter by Status:
                  </label>
                  <div className="w-100" style={{ maxWidth: 200 }}>
                    <Select
                      placeholder="Filter by Status"
                      className="react-select__menu"
                      classNamePrefix="select"
                      name="selectedStatus"
                      options={doctorSpecialities}
                      value={selectedStatus}
                      onChange={(selectedOption) => {
                        setSelectedStatus(selectedOption);
                        setPageNo(1);
                        setSearchQuery("");
                      }}
                    />
                  </div>
                </div>
                <div className="search-bar col-lg-3 col-md-3">
                  <label
                    htmlFor="statusFilter"
                    className="white-space-nw"
                    style={{ marginRight: "8px", fontSize: "14px" }}
                  >
                    Search by:
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Name or Email"
                    value={searchQuery}
                    onChange={handleSearch}
                  />
                </div>
              </div>
              <div className="table-responsive">
                <div className="search-bar"></div>
                <table
                  id="mangeUser"
                  className="table table-hover dataTable js-exportable"
                >
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Patient Name</th>
                      {/* <th>Phone Number</th> */}
                      <th>Email Address</th>
                      <th>Date Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {patientMeetingStatusList &&
                      patientMeetingStatusList.map((item, index) => {
                        return (
                          <tr id={item.id} key={index}>
                            <td>{item.id}</td>

                            <td>
                              <h3 className="doc-details">
                                <div className="doc-profile">
                                  <img src={item?.user?.profile_image} alt="" />
                                </div>
                                {item?.user?.first_name +
                                  " " +
                                  item?.user?.last_name}
                              </h3>
                            </td>
                            {/* <td>
                              {item?.patient_information?.country_code +
                                " " +
                                item?.patient_information?.patient_phone_no}
                            </td> */}
                            <td>{item?.user?.email}</td>
                            <td>
                              {/* {moment.utc(item.appointment_date + " " + item.appointment_time).tz(userTimezone).format('DD/MM/YYYY hh:mm A')} */}
                              {moment
                                .tz(
                                  `${item?.createdAt}`,
                                  "YYYY-MM-DD hh:mm A",
                                  "UTC"
                                )
                                .tz(userTimezone)
                                .format("DD/MM/YYYY hh:mm A")}
                            </td>
                            <td>
                              <div
                                className="d-flex gap-2 flex-wrap align-items-center"
                                style={{ maxWidth: 300 }}
                              >
                                <>
                                  {params?.isPriestMeeting != "true" && (
                                    <button
                                      className="commonBtn btn-sm px-2"
                                      onClick={() =>
                                        handleAutoRx(item.meeting_id, item)
                                      }
                                    >
                                      {" "}
                                      AutoRx
                                    </button>
                                  )}
                                  <button
                                    className="commonBtn btn-sm px-2"
                                    onClick={() =>
                                      handleMeetiRecord(item.meeting_id)
                                    }
                                  >
                                    {" "}
                                    Meeting Record
                                  </button>
                                  <button
                                    className="commonBtn btn-sm px-2"
                                    onClick={() =>
                                      isOpenMailModal(item.meeting_id)
                                    }
                                  >
                                    {" "}
                                    Mail Record
                                  </button>
                                </>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
                <ReactPaginate
                  breakLabel="..."
                  nextLabel=" > "
                  onPageChange={handlePageClick}
                  pageCount={totalRecordCount}
                  previousLabel=" < "
                  renderOnZeroPageCount={null}
                  containerClassName="pagination"
                  pageLinkClassName="page-link"
                  previousLinkClassName="page-link"
                  nextLinkClassName="page-link"
                  disabledClassName="disabled"
                  activeClassName="active"
                  activeLinkClassName="active-link"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default SingleUserHistory;
